import { logFormData } from 'shared/lib/logFormData';

import type { TPassportFormFields } from 'entities/creditForm';
import { sendStepsAnalyticsEvents, setPassportInfo } from 'entities/creditForm';

import { PassportInfoTexts } from 'features/UpdatePassportInfo';

export const submitPassportForm =
  (actualData: TPassportFormFields): ThunkResult<void> =>
  async (dispatch) => {
    dispatch(setPassportInfo({ data: actualData, isFullFilled: true }));
    logFormData('PassportInfo FormStep SubmitData', actualData);
    dispatch(sendStepsAnalyticsEvents([2], PassportInfoTexts, 'manual'));
  };
